/* eslint-disable no-irregular-whitespace */
<template>
  <div class="p-menu">
    <div class="l-container" ref="screenTop">
      <div class="c-box mb-12 mt-px">
        <MenuDetailHeader v-model="menuBasicInfo" @gotoMap="scrollToMap"/>
        <MenuNavigation :data="menuNavigations"/>

        <div class="menu-main-content">
          <section >
            <div class="main-top">
              <div class="main-top-left" v-if="false">
                <div class="item">
                  <Rating :rate="rate.rateAvg" />
                </div>
                <div class="item">
                  <div class="comment">
                    <i class="icon icon-bor-bubble" />
                  </div>
                  <span class="count">{{ commentCount | formatInteger }}</span>
                </div>
                <div class="item">
                  <div class="like">
                    <i class="icon icon-bor-heart" />
                  </div>
                  <span class="count">{{ favoriteCount | formatInteger }}</span>
                </div>
              </div>
              <div class="main-top-right">
                <div
                  class="label label-grey-200"
                  v-for="(tag, index) in menuIcons"
                  :key="`tag-${index}`"
                >
                  {{ tag.iconNm }}
                </div>
              </div>
            </div>
          </section>

          <!-- /* Carousel */ -->
          <section class="lg:pl-4">
            <div class="main-demo">
              <div class="menu-carousel">
                <CarouselThumbnail
                  :slides="menuImages"
                  class="mb-4 lg:hidden"
                />
                <div class="menu-price hidden lg:flex mb-4">
                  <div class="label label-primary">最安値</div>
                  <div class="price-content">
                    <strong>15,600</strong>
                    <span>円～／室 （7,800円/人）</span>
                  </div>
                </div>
                <div class="slide-images-mobile hidden lg:flex overflow-x-auto" v-if="menuImages">
                  <img v-for="(item, index) in menuImages" :key="`menuImages-${index}`"
                    :src="`${item.imageUrl}`"
                    :alt="`${item.imageExplanation}`"
                  />
                </div>
                <a @click="gotoGallery" class="leading-none text-black lg:text-right inline-block w-full">
                  フォトギャラリーを見る
                  <i class="icon icon-bor-arrow-right text-primary text-sm pl-2 leading-none"/>
                </a>
              </div>
              <div class="menu-calendar">
                <div class="menu-price flex lg:hidden">
                  <div class="label label-primary">最安値</div>
                  <div class="price-content">
                    <strong>{{ menuPrice | formatCurrency('') }}</strong>
                    <span>円～／室 （{{(menuPrice / 2) | formatCurrency('')}}円/人）</span>
                  </div>
                </div>
                <div class="menu-calendar-title">
                  <h4>{{ menuStatus }}</h4>
                </div>
                <Calendar v-model="stayDay" @input="stayDay = $event"
                              :selectedDays="getSelectedDays"
                              :dayOpens="filterOpenDays"
                              :dayOpenDecorator="dayOpenDecorator"
                              :dayFewLefts="filterFewLeftDays"
                              :fewLeftDecorator="fewLeftDecorator"
                              :dayCloses="filterCloseDays"
                              :dayClosedDecorator="dayClosedDecorator"
                              :disabledDate="checkDisabledDate"
                              :disabledPrev="calendarDisabledPrev"/>
                <div class="calendar-selection">
                  <div class="round-selection">○ 空席あり</div>
                  <div class="triangle-selection">△ 残りわずか</div>
                  <div class="x-selection">× 販売終了</div>
                </div>
              </div>
            </div>
          </section>

          <!-- Information -->
          <section>
            <div class="main-information">
              <div class="box-content" v-if="menuBasicInfo">
                <h3>
                  {{ menuBasicInfo.catchCopy }}
                </h3>
                <p class="whitespace-pre-wrap"
                   v-html="menuBasicInfo.leadCopy"
                   v-show="menuBasicInfo && menuBasicInfo.leadCopy">
                </p>
              </div>
              <!-- <div class="main-information-refer lg:flex-wrap">
                <div
                  class="
                    label label-grey-200 label-lg
                    w-auto
                    lg:w-full lg:mb-2
                    justify-center
                    lg:justify-start
                  "
                >
                  #1F2021
                </div>
                <div class="list-links">
                  <a href="#">＃ファミリー向け</a>
                  <a href="#">＃女子旅</a>
                  <a href="#">＃疲れをリセット</a>
                  <a href="#">＃健康管理</a>
                  <a href="#">＃社内合宿</a>
                </div>
              </div> -->
            </div>
          </section>

          <!-- Viewmore -->
          <section v-if="menuBasicInfo && Array.isArray(menuBasicInfo.menuInformation)">
            <SectionContentTitle :lineType="lineType.vertical" titleContent="インフォメーション" />
            <div class="main-description" v-for="(menu, index) in menuBasicInfo.menuInformation" :key="`memuInfo-${index}`">
              <BoxViewMore>
                <h3 v-show="menu.title">{{ menu.title }}</h3>
                <p class="whitespace-pre-wrap mb-3" v-html="menu.content" style="min-height: 15px;">
                </p>
                <a class="blue" :href="`${menu.linkUrl}`">{{menu.linkNm ? menu.linkNm : menu.linkUrl}}</a>
              </BoxViewMore>
            </div>
          </section>

          <!-- Box Text Recomenteded -->
          <section>
            <div class="main-recommended">
              <SectionContentTitle :lineType="lineType.vertical" titleContent="おすすめのプラン" />
              <div class="box-content">
                <div class="flex items-start recommended-title">
                  <div class="label label-primary mt-2 mr-4">NEW</div>
                  <h3>
                    キャッチコピーが入りますキャッチコピーが入ります。キャッチコピーが入りますキャッチコピーが入ります。キャッチコピーが入りますキャッチコピーが入ります。キャッチコピーが入りますキャッチコピーが入ります。
                  </h3>
                </div>
              </div>
              <div class="main-recommended-footer">
                <div class="recommended-left">
                  <img src="@/assets/images/recomment-rakuten.png" alt="demo" />
                  <div class="services-offer">
                    <div class="item">
                      <i class="icon icon-bor-food" />
                      <span>朝食のみ</span>
                    </div>
                  </div>
                </div>
                <div class="recommended-right">
                  <div class="label label-grey-200">現地決済予約</div>
                  <div class="label label-grey-200">事前決済予約</div>
                  <div class="label label-grey-200">カフェポイント</div>
                  <div class="label label-grey-200">すくすくえいど</div>
                  <div class="label label-grey-200">介護補助</div>
                </div>
              </div>
            </div>
          </section>

          <!-- Divider -->
          <section>
            <div class="divider"></div>
          </section>

          <!-- List Hotel -->
          <section>
            <div class="list-hotel">
              <HotelItem
                :data="plan"
                v-for="(plan, index) in plans"
                :key="`plan-${index}`"
              />
            </div>
          </section>

          <div class="divider" />

          <!-- Map -->
          <section>
            <div class="main-detail" ref="googleMap">
              <div class="main-map">
              <iframe
                width="100%"
                height="500"
                style="border:0"
                loading="lazy"
                allowfullscreen
                :src="`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_KEY}&q=${latitude},${longitude}`">
              </iframe>

                <div class="flex justify-end mt-2">
                  <a @click="openMap" target="_blank">
                    <span class="text-black">Google Mapで見る</span>
                    <i class="icon icon-bor-arrow-right text-primary pl-2" />
                  </a>
                </div>
              </div>
              <div class="divider my-6" />
              <div class="main-detail-information">
                <div class="item-detail-label w-full">
                  <div class="label label-lg label-grey-200">住所</div>
                  <div class="item-detail-content" v-if="facilities && facilities.facilityAddress">
                    〒{{zipCode}} {{ facilities.facilityAddress }}
                  </div>
                </div>
                <div class="item-detail-label w-full">
                  <div class="label label-lg label-grey-200">アクセス</div>
                  <div class="item-detail-content" v-if="facilities && facilities.access">
                    {{ facilities.access }}
                    <!-- <div class="item-line">
                      <label>自動車：</label>
                      <p>
                        首都高速道路都心環状線 新橋出入口より 約 10分
                        首都高速道路都心環状線 汐留出入口より 約 10分
                      </p>
                    </div> -->
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">駐車場</div>
                  <div class="item-detail-content" v-if="facilities && facilities.equipServices">
                    {{ facilities.equipServices }}
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">無料送迎</div>
                  <div class="item-detail-content" v-if="facilities && facilities.equipServices">
                    {{ facilities.equipServices }}
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">TEL</div>
                  <div class="item-detail-content" v-if="facilities && facilities.facilityTelNo">
                    {{ facilities.facilityTelNo }}
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">FAX</div>
                  <div class="item-detail-content" v-if="facilities && facilities.facilityFax">
                    <div class="item-line">
                      {{ facilities.facilityFax }}
                    </div>
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">メール</div>
                  <div class="item-detail-content" v-if="facilities && facilities.facilityEmail">
                    {{ facilities.facilityEmail }}
                  </div>
                </div>
                <div class="item-detail-label" >
                  <div class="label label-lg label-grey-200">お問い合わせ</div>
                  <div class="item-detail-content" v-if="facilities && facilities.facilityInqForm">
                    {{ facilities.facilityInqForm }}
                    <a :href="`${facilities.facilityInqForm}`" target="_blank"><i class="ml-2 icon icon-bor-full-screen" /></a>
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">URL</div>
                  <div class="item-detail-content" v-if="facilities && facilities.facilityUrl">
                    {{ facilities.facilityUrl }}
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">
                    公式アカウント
                  </div>
                  <div class="item-detail-content" v-if="facilities && facilities.snsOfclAccts">
                    <p class="flex items-center">
                      <a class="pr-4" :href="`${facilities.snsOfclAccts}`">
                        <img src="@/assets/images/Instagram.png" alt="icon"/>
                      </a>
                      <a class="pr-4" :href="`${facilities.snsOfclAccts}`">
                        <i class="icon icon-bor-twitter text-xl"/>
                      </a>
                      <a class="pr-4" :href="`${facilities.snsOfclAccts}`">
                        <i class="icon icon-bor-facebook text-xl"/>
                      </a>
                    </p>
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">定休日</div>
                  <div class="item-detail-content" v-if="facilities && Array.isArray(facilities.regularlyCloseds) && facilities.regularlyCloseds.length > 0">
                    {{ facilities.regularlyCloseds[0] }}
                  </div>
                </div>
                <div class="item-detail-label">
                  <div class="label label-lg label-grey-200">特典</div>
                  <div class="item-detail-content" v-if="facilities && facilities.equipServices">
                    {{ facilities.equipServices }}
                  </div>
                </div>
              </div>
              <div class="divider mb-8 lg:mb-6 mt-0" />
              <div class="main-footer">
                <p class="mb-2 text-black">
                  ［注意事項］
                  店舗情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。
                </p>
                <p class="text-primary">
                  ※施設に直接お申込みいただくことは出来ません。
                  直接お申込みの場合、弊社プランへの予約変更は出来ないことをご了承ください。
                </p>
                <p class="text-primary">
                  &emsp; 上記タブ「プラン一覧」からお申込みください。
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Recommended -->
      <section class="mb-12 p-0 lg:pl-5" v-if="aroundServices && aroundServices.length">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="周辺のおすすめサービス"
        />
        <div class="list-recommended-services">
          <RecommendedItem  v-for="(item, index) in aroundServices.slice(0, 4)" :key="`recommended-${index}`" :recommended_data="item" />
        </div>
      </section>

      <section class="mb-12 p-0 lg:pl-5" v-if="menuCategoryTag && sameCategoryMenus && sameCategoryMenus.length">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="同じカテゴリのサービス"
        />
        <div class="list-recommended-services" >
          <RecommendedItem v-for="(item, index) in sameCategoryMenus.slice(0, 4)" :key="`recommended-${index}`" :recommended_data="item" />
        </div>
      </section>

      <!-- <section class="mb-20 p-0 lg:pl-5">
        <SectionContentTitle
          :lineType="lineType.horizontal"
          titleContent="おすすめの特集・イベント"
        />
        <CarouselEvents :img="dataImg" />
      </section> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import moment from 'moment'
import _ from 'lodash'
import mark_watched from '@/mixins/mark_watched.js'

import {
  MenuNavigation,
  HotelItem,
  CarouselThumbnail,
  // CarouselEvents,
  BoxViewMore,
  SectionContentTitle
} from '@/components/compound'
import { Rating, Calendar } from '@/components/primitive'
import { GET_MENU_BASIC_INFO, GET_MENU_STAY, GET_SAME_CATEGORY_MENUS, GET_FACILITIES } from '@/store/modules/menu/actions.js'
import MenuDetailHeader from './MenuDetailHeader'
import RecommendedItem from './RecommendedItem'
import { BREADCRUMBS } from '@/store/modules/app/actions'

export default {
  mixins: [mark_watched],
  components: {
    CarouselThumbnail,
    // CarouselEvents,
    Calendar,
    MenuNavigation,
    Rating,
    HotelItem,
    RecommendedItem,
    BoxViewMore,
    SectionContentTitle,
    MenuDetailHeader
  },
  data() {
    return {
      menuNavigations: [
        {
          icon: 'icon-bor-information',
          labelDesktop: '基本情報',
          labelMobile: '基本情報',
          active: true,
          route: '/bs-02-001',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-plan',
          labelDesktop: 'プラン',
          labelMobile: 'プラン',
          active: false,
          route: '/bs-pnl-02-001',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-img',
          labelDesktop: 'フォトギャラリー',
          labelMobile: 'フォト',
          active: false,
          route: '/bs-men-02-020',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-care',
          labelDesktop: '設備・サービス詳細',
          labelMobile: '設備・詳細',
          active: false,
          route: '/bs-men-02-030',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-bubble',
          labelDesktop: 'クチコミ',
          labelMobile: 'クチコミ',
          active: false,
          route: '/bs-men-02-040',
          query: this.$route.query
        }
      ],
      open: false,
      menuBasicInfo: null,
      vacancyCalendar: null,
      menuIcons: [],
      menuImages: [],
      menuHashtags: [],
      photoGallery: null,
      plans: [],
      facilities: null,
      equipServices: [],
      serviceAreas: null,
      rate: {
        rateAvg: 4.5
      },
      favoriteCount: 1234,
      commentCount: 5353535,
      minPrice: 0,
      menuStatus: null,
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      dateFormat: 'YYYY/MM/DD',
      instockDayMap: {},
      fewLeftDayMap: {},
      outstockDayMap: {},
      stayDay: moment(new Date()),
      equipmentServices: [],
      sameCategoryMenus: [],
      breadcrumbs: [],
      latitude: 0,
      longitude: 0,
      GOOGLE_MAP_KEY: 'AIzaSyDYDgespYtyMc8ELnoEnw8sWb80xxDNJHg',
      aroundServices: [],
      zipCode: ''
    }
  },
  watch: {
    // '$route.query.menuNo'() {
    //   this.getMenuBasicInfo()
    //   this.getRecommendServices()
    //   this.$smoothScroll({
    //     scrollTo: this.$refs.screenTop
    //   })
    // }
  },
  computed: {
    getMenuDetailInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'menu.menuDetail', null))
    },
    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = this.stayDay.format(this.dateFormat)
        return [stayDay]
      }
      return []
    },
    filterOpenDays() {
      this.instockDayMap = {}
      let vacancyCalendars = this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars ? this.vacancyCalendar.vacancyCalendars : []
      vacancyCalendars = vacancyCalendars.filter(e => e.stock > 4 || e.stock === 0)
      const instockDays = []
      vacancyCalendars.forEach(el => {
        this.instockDayMap[el.stayDay] = true
        instockDays.push(el.stayDay)
      })
      return instockDays
    },
    filterFewLeftDays() {
      this.fewLeftDayMap = {}
      let vacancyCalendars = this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars ? this.vacancyCalendar.vacancyCalendars : []
      vacancyCalendars = vacancyCalendars.filter(e => e.stock > 0 && e.stock <= 4)
      const fewLeftDays = []
      vacancyCalendars.forEach(el => {
        this.fewLeftDayMap[el.stayDay] = el.stock
        fewLeftDays.push(el.stayDay)
      })
      return fewLeftDays
    },
    filterCloseDays() {
      this.outstockDayMap = {}
      const lastDay = moment(this.stayDay).endOf('month').date()
      const vacancyCalendars = this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars ? this.vacancyCalendar.vacancyCalendars : []
      const inStockDays = vacancyCalendars.map(e => e.stayDay)
      const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month = this.stayDay.month() + 1 > 9 ? this.stayDay.month() + 1 : `0${this.stayDay.month() + 1}`
        const day = `${this.stayDay.year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          this.outstockDayMap[day] = true
          closeDays.push(day)
        }
      }
      return closeDays
    },
    calendarDisabledPrev() {
      const now = moment(new Date())
      return this.stayDay.isSameOrBefore(now, 'month')
    },
    menuPrice() {
      if (!this.vacancyCalendar) {
        return 0
      }
      const min = Math.min(...this.vacancyCalendar.vacancyCalendars.map(e => e.price))
      return min
    },
    menuCategoryTag() {
      let categoryTag = ''
      if (this.menuBasicInfo) {
        if (_.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')) {
          categoryTag = _.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')
        } else if (_.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')) {
          categoryTag = _.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
        } else if (_.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')) {
          categoryTag = _.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
        }
      }
      return categoryTag
    }
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
  },
  mounted() {
    // this.getMenuBasicInfo()
    this.getMenuStayInfo()
  },
  methods: {
    getMenuBasicInfo() {
      const { menuNo } = this.$route.query
      this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
        (data) => {
          this.menuBasicInfo = data
          this.latitude = _.get(this.menuBasicInfo, 'areaInfomation.latitude')
          this.longitude = _.get(this.menuBasicInfo, 'areaInfomation.longitude')
          this.menuImages = _.get(this.menuBasicInfo, 'menuImages', [])
          this.facilities = _.get(data, 'storeList.facilities[0]', null)
          if(this.facilities && this.facilities.zipCode) {
            this.zipCode = `${this.facilities.zipCode.substring(0, 3)  }-${  this.facilities.zipCode.substring(3, 7)}`
          }
          // update breadcrumbs
          this.breadcrumbs.push({
            path: '/bs-02-001',
            title: _.get(this.menuBasicInfo, 'menuNm', '')
          })
          this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
          this.getFacilities()
          this.getRecommendServices()
        }
      )
    },
    getMenuStayInfo() {
      const { menuNo } = this.$route.query
      this.$store.dispatch(GET_MENU_STAY, { menuNo }).then(
        (data) => {
          this.menuBasicInfo = data.menuBasicInfo
          this.latitude = _.get(this.menuBasicInfo, 'areaInfomation.latitude')
          this.longitude = _.get(this.menuBasicInfo, 'areaInfomation.longitude')
          this.menuImages = _.get(this.menuBasicInfo, 'menuImages', [])
          this.facilities = _.get(data, 'facilities.facilities[0]', null)
          if(this.facilities && this.facilities.zipCode) {
            this.zipCode = `${this.facilities.zipCode.substring(0, 3)  }-${  this.facilities.zipCode.substring(3, 7)}`
          }
          // update breadcrumbs
          this.breadcrumbs.push({
            path: '/bs-02-001',
            title: _.get(this.menuBasicInfo, 'menuNm', '')
          })
          this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
          this.getFacilities()
          this.getRecommendServices()
        },
        (error) => {
          this.$toasted.error(error?.message)
        })
    },
    getFacilities() {
      this.$store.dispatch(GET_FACILITIES, {
        latitude: this.latitude,
        longitude: this.longitude,
        page: 1
      }).then(
        (result) => {
          if (result && Array.isArray(result)) {
            this.aroundServices = result
          }
        },
        (error) => {
          this.$toasted.error(error?.message)
        })
    },
    getRecommendServices() {
      const { catLrgClassCd, catMidClassCd, catSmlClassCd } = _.get(this.menuBasicInfo, 'categoryInfomation', {})
      this.$store.dispatch(GET_SAME_CATEGORY_MENUS, { catLrgClassCd, catMidClassCd, catSmlClassCd }).then(
        (data) => {
          this.sameCategoryMenus = data
        }
      )
    },

    checkDisabledDate($event) {
      const now = moment(new Date())
      return $event.isBefore(now, 'date')
    },
    dayOpenDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars = this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars ? _.cloneDeep(this.vacancyCalendar.vacancyCalendars) : []
      const instockDays = vacancyCalendars.filter(e => e.stock > 4 || e.stock === 0).map(el => el.stayDay)
      return !$event.isBefore(now, 'date') && instockDays.includes($event.format(this.dateFormat)) ? '○' : ''
    },
    fewLeftDecorator($event) {
      const now = moment(new Date())
      let vacancyCalendars = this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars ? this.vacancyCalendar.vacancyCalendars : []
      vacancyCalendars = vacancyCalendars.filter(e => e.stock > 0 && e.stock <= 4 && e.stayDay === $event.format('YYYY/MM/DD'))
      // return !$event.isBefore(now, 'date') ? `<span class="text">${vacancyCalendars.length ? vacancyCalendars[0].stock : null}</span>` : ''
      return !$event.isBefore(now, 'date') ? `<span class="text">${vacancyCalendars.length ? '△' : null}</span>` : ''
    },
    dayClosedDecorator($event) {
      const now = moment(new Date())
      const vacancyCalendars = this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars ? this.vacancyCalendar.vacancyCalendars : []
      const inStockDays = vacancyCalendars.map(e => e.stayDay)
      return !$event.isBefore(now, 'date') && !inStockDays.includes($event.format(this.dateFormat)) ? '×' : ''
    },

    scrollToMap() {
      this.$smoothScroll({
        scrollTo: this.$refs.googleMap,
        offset: -120
      })
    },
    openMap() {
      if (this.latitude && this.longitude) {
        window.open(`https://maps.google.com/?q=${this.latitude},${this.longitude}`)
      } else {
        window.open('https://maps.google.com')
      }
    },
    gotoGallery() {
      const query = this.$route.query
      this.$router.push({path: 'bs-men-02-020', query})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
